export default "__VITE_ASSET__q3o$5hjP__"